import React from 'react';
import DetailDialog from '@/common/detail-dialog';
import './index.less';

interface BnplPayment {
  bnplPaymentMethods: BnplPaymentMethod[];
}

interface BnplPaymentMethod {
  icon: string;
  instrumentCode: string;
  message: string;
  readMoreUrl: string;
}

export default function BNPLPayment({
  bnplPayment,
  i18n,
}: {
  bnplPayment: BnplPayment;
  i18n: DetailTypes.i18n;
}) {
  if (!bnplPayment) return null;
  const { bnplPaymentMethods = [] } = bnplPayment;
  if (bnplPaymentMethods.length === 0) return null;

  return (
    <div className="detail-bnplPayment-layout">
      {bnplPaymentMethods.map((bnplPaymentMethod, index) => (
        <div className="bnplPayment-item" key={index}>
          <img className="bnplPayment-icon" src={bnplPaymentMethod.icon} alt="bnplPayment-icon" />
          <span>{bnplPaymentMethod.message}</span>
          {/* 外链弹框 */}
          <DetailDialog
            iframeUrl={bnplPaymentMethod.readMoreUrl}
            title="BnplPayment View"
            style={{ width: '1000px' }}
          >
            <a className="bnplPayment-link">{i18n['companyCardIntegrated.starLevel.more']}</a>
          </DetailDialog>
        </div>
      ))}
    </div>
  );
}
